export interface IPageParams {
  page: number;
  limit: number;
}

export interface ISortData {
  orderBy?: string;
  orderType?: OrderType | null;
}

export enum OrderType {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface IDropdownOptions {
  optionId?: number;
  label: string;
  value: string | number;
  id?: string | number;
  disabled?: boolean;
}

export interface IOptionType {
  value: string | number | boolean;
  label: string;
}

export interface ApiErrorResponse {
  message?: string | string[];
  error?: string;
  statusCode?: number;
}

export interface FetchError extends Error {
  response?: {
    data?: ApiErrorResponse;
    status?: number;
  };
}

export interface ApiResponse<T> {
  data: T;
}
